import { render } from "./newHome.vue?vue&type=template&id=6c90c176&scoped=true"
import script from "./newHome.vue?vue&type=script&lang=js"
export * from "./newHome.vue?vue&type=script&lang=js"

import "./newHome.vue?vue&type=style&index=0&id=6c90c176&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c90c176"]])

export default __exports__